import React from "react";

export default function Credit() {
  return (
    <div class="credit">
    <p>
      Coded by
      <a href="https://github.com/yatikakain"
        > Yatika Kain</a
      >
    </p>
  </div>
  );
}